module.exports = __webpack_public_path__ + "img/upbestvalue.ef0f6192.svg";